/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Check if the current URL matches a specific condition
// INFINITE COLLECTION
// var pInfScrLoading = false;
// var pInfScrDelay = 100;

// function pInfScrExecute() {
//   console.log("idfff");
//   var loadingImage;
//   pInfScrNode = $(".product-list__inner").last().find(".more").last();
//   pInfScrURL = $(".product-list__inner").last().find(".more a").last().attr("href");
//   if (!pInfScrLoading && pInfScrNode.length > 0) {
//     console.log("innnnnidfff");
//     $(".product-facet__main").append(
//       '<img src="https://cdn.shopify.com/s/files/1/0529/2746/3613/files/loader.gif?v=1755664357" class="loading" style="display:block; margin:auto;" />'
//     );
//     $.ajax({
//       type: "GET",
//       url: pInfScrURL,
//       beforeSend: function () {
//         pInfScrLoading = true;
//         loadingImage = pInfScrNode.clone().empty().append("");
//         loadingImage.insertAfter(pInfScrNode);
//         pInfScrNode.hide();

//         console.log("loading...");
//       },
//       success: function (data) {

//         console.log('data',data);
//         // remove loading feedback
//         pInfScrNode.next().remove();
//         var filteredData = $(data).find(".product-list__inner");
//         filteredData.insertBefore($("#product-list-foot"));
//         loadingImage.remove();
//         pInfScrLoading = false;
//         $(".product-facet__main").find(".loading").remove();
//         pInfScrLoading = false;
//         var newMoreLink = $(data).find(".more a").last().attr("href");
//         if (!newMoreLink) {
//           $("#collection-sec-ftr-btn").remove();
//         }
//         document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
//         try {
//           if (typeof iWish !== 'undefined' ){
//               iWish.checkIwishColl();
//           }
//         } catch (error) {
//           console.log(error);
//         }
//       },
//       dataType: "html",
//     });
//   }
// }



// if (!$(".product-list-inner").find(".more").length) {
//   $("#collection-load-more").remove();
// }
// $(document).ready(function () {
//   $(window).scroll(function(){
//     console.log($(document).height(),$(document).scrollTop(),$(window).height())
//     if( $(document).height() - 800 < $(document).scrollTop() + $(window).height() ) {
//       pInfScrDelay = 100;
//       $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
//     }
//   });
// });

// $.doTimeout("scroll", pInfScrDelay, pInfScrExecute());
// $("body").on("click", "#collection-load-more", function () {
//   pInfScrExecute();
// });

if($('body').hasClass('template-search')  || $('body').hasClass('template-collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 20;
  
  function pInfScrExecute() {
    var loadingImage;
    pInfScrNode = $('.product-list__inner').find('.more');	        
    // removeing this condition && pInfScrNode.css('display') != 'none'
    if(!pInfScrLoading && pInfScrNode.length > 0) {
      pInfScrURL = $('.product-list__inner').find('.more a').attr("href");
      $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0529/2746/3613/files/loader.gif?v=1755664357" class="loading" style="display:block; margin:auto;" />');
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          
          console.log('loading...');
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $(data).find(".product-list__inner");
          // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
          $('.product-list__inner').find('.more').before(filteredData.html());
          $('.product-list__inner').find('.more:not(:last-child)').remove();
          if(filteredData.find('.more').length > 0){
            $('.product-list__inner').find('.more').html(filteredData.find('.more').html());
          }else{
            $('.product-list__inner').find('.more').remove();
          }
          
          
          loadingImage.remove();	              
          $('.product-list').find('.loading').remove();
          pInfScrLoading = false;
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          try {
            if (typeof iWish !== 'undefined' ){
                iWish.checkIwishColl();
            }
          } catch (error) {
            console.log(error);
          }
        },
        dataType: "html"
      });
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
        $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
        pInfScrDelay = 20;
      }
    });
  });
}

const checkInterval = setInterval(() => {
  const el = document.querySelectorAll("_grid_1q1d2_148");
  if (el.length) {
    clearInterval(checkInterval);
    setTimeout(() => {
      // add a CSS class instead
      el.classList.add("highlighted");
      console.log('dfsdffd');
    }, 8000);
  }
}, 500);

$(document).ready(function () {

  if (window.location.search.indexOf('opencartdrawer=1') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace(/[?&]opencartdrawer=1/, '');
    history.replaceState(null, '', url);
  }
  
  $(".testimonial-custom-row").slick({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  $(".featured-product-list_grid").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg focusable="false" width="17" height="14" viewBox="0 0 17 14">
        <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2" fill="none"></path>
      </svg></button>`,
    nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg focusable="false" width="17" height="14" viewBox="0 0 17 14">
        <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path>
      </svg></button>`,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 740,
        settings: "unslick",
      },
    ],
  });

  $(".featured-collection-third-list").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        }
      },
    ],
  });

  $(".image-video-list").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 740,
        settings: "unslick",
      },
    ],
  });

  $(".as-seen-on-blocks").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 740,
        settings: "unslick",
      },
    ],
  });

  $(".as-seen-on-modal-blocks").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false
  });

  $('body').on('click','.as-seen-on-block', function(){
    $('html').addClass('no-scroll');
    $(this).closest('.as-seen-on-inner').find('.as-seen-on-modal').addClass('active');
    let slideno = $(this).data('slide') - 1;
    $(this).closest('.as-seen-on-inner').find('.as-seen-on-modal-blocks').slick('slickGoTo', slideno);
    const video = $(this).closest('.as-seen-on-inner').find('.as-seen-on-modal-blocks .as-seen-on-modal-block.slick-slide.slick-current.slick-active').find('video')[0];
    video.currentTime = 0;   // restart from beginning
    video.muted = false;
    video.play().catch(err => {
      console.log('Autoplay prevented:', err);
    });
 });

  $('.as-seen-on-modal-blocks').on('init afterChange', function(event, slick, currentSlide){
    var current = currentSlide || 0;
    console.log('current', current);
    var $slider = $(this);
    //current slide video
    var slidevideo = $slider
        .find('.slick-slide[data-slick-index="' + current + '"] video')[0];
    if (slidevideo) {
        slidevideo.play().catch(err => {
            console.log('Autoplay prevented:', err);
        });
    }
    //prev slide video
    var prevVideo = $slider
        .find('.slick-slide[data-slick-index="' + (current - 1) + '"] video')[0];
    if (prevVideo) {
        prevVideo.pause();
        prevVideo.currentTime = 0;
    }
    //next slide video
    var nextVideo = $slider
        .find('.slick-slide[data-slick-index="' + (current + 1) + '"] video')[0];
    if (nextVideo) {
        nextVideo.pause();
        nextVideo.currentTime = 0;
    }
  });

  $('body').on('click', '.as-seen-on-close-modal, .as-seen-on-modal-overlay', function (){
    $('.as-seen-on-modal').removeClass('active');
    $('.as-seen-on-modal-blocks .as-seen-on-modal-block video').each(function() {
      this.pause();
      $('html').removeClass('no-scroll');
    });
 })

  $(".featured-collection-sec-list").slick({
    dots: false,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".celebrati-closet_item-list.slider").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: "unslick",
      },
    ],
  });

  var firstTitle = $(".product-form__dropdown-title").first();
  if (window.innerWidth > 768) {
    firstTitle.addClass("active");
    firstTitle.next(".product-form__dropdown-content").slideDown();
  }
  $("body").on("click", ".product-form__dropdown-title", function () {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".product-form__dropdown-content");
    $(".product-form__dropdown-title").not(activeTitle).removeClass("active");
    $(".product-form__dropdown-content").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

  // FAQ SECTION
  // var firstTitle = $(".faq-sec-item-toggle").first();
  // if (window.innerWidth > 768) {
  //   firstTitle.addClass("active");
  //   firstTitle.next(".faq-sec-item-content").slideDown();
  // }
  $("body").on("click", ".faq-sec-item-toggle", function () {
    var activeTitle = $(this);
    activeTitle.toggleClass("active");
    var currentDropdown = activeTitle.next(".faq-sec-item-content");
    $(".faq-sec-item-toggle").not(activeTitle).removeClass("active");
    $(".faq-sec-item-content").not(currentDropdown).slideUp();
    currentDropdown.stop(true, true).slideToggle();
  });

  $("body").on("click", ".header-dropdown-open", function (e) {
    e.stopPropagation(); // Prevent bubbling to document click handler

    // First hide all menus
    $(".mega-menu, .nav-dropdown").attr("hidden", true);

    // Then show the related one
    $(this)
      .closest(".header__linklist-item")
      .find(".mega-menu, .nav-dropdown")
      .removeAttr("hidden");
  });

  // Hide menu when mouse leaves the menu
  $("body").on("mouseleave", ".mega-menu, .nav-dropdown", function () {
    $(this).attr("hidden", true);
  });

  // Optional: Hide all menus if clicking anywhere else on the page
  $(document).on("click", function () {
    $(".mega-menu, .nav-dropdown").attr("hidden", true);
  });

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this).find(".product-offer-copied");
    var text = $(this)
      .closest(".product-offer-block")
      .find(".product-offer-code")
      .text();
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html("Copied");
    setTimeout(function () {
      copy_text.html("");
    }, 1000);
  });

  $('body').on('click', '.product-meta__share-button-item--copylink', function(e) {
    e.preventDefault();  
    var copy_text = $(this).find(".show_copied_text");
    var link = $(this).attr('href');  
    var $tempInput = $('<input>');
    $('body').append($tempInput);
    $tempInput.val(link).select();
    document.execCommand('copy');
    $tempInput.remove();
    copy_text.html("Link copied"); 
    setTimeout(function () {
      copy_text.html("");
    }, 1000);
  });

 // Initialize original values as data attributes
  $(".size-chart-item_content table tbody tr").each(function () {
    $(this)
      .find("td:not(:first-child)")
      .each(function () {
        const text = $(this).text().trim();

        // Case 1: Range value (30-34)
        if (text.includes("-")) {
          const parts = text.split("-").map(v => parseFloat(v.trim()));

          if (parts.length === 2 && !parts.some(isNaN)) {
            const inRange = `${parts[0]}-${parts[1]}`;
            const cmRange = `${Math.round(parts[0] * 2.54)}-${Math.round(parts[1] * 2.54)}`;

            $(this).attr("data-in", inRange);
            $(this).attr("data-cm", cmRange);
            $(this).text(cmRange);
          }
          return;
        }

        // Case 2: Single numeric value
        const value = parseFloat(text);
        if (!isNaN(value)) {
          $(this).attr("data-in", value);
          $(this).attr("data-cm", Math.round(value * 2.54));
          $(this).text(Math.round(value * 2.54));
        }
      });
  });

  $("body").on("click", ".size-chart-converter_item", function () {
    var $sizeChartItem = $(this).closest(".size-chart-item"); // Get parent chart item
    $sizeChartItem.find(".size-chart-converter_item").removeClass("active");
    $(this).addClass("active");

    // Determine the selected unit
    const unit = $(this).data("type"); // "CM" or "IN"

    // Update checkbox state
    var $unitToggle = $sizeChartItem.find(".unitToggle");
    $unitToggle.prop("checked", unit === "CM");

    // Update table values
    updateTableValues($sizeChartItem, unit);
  }); 

  // Listen for checkbox changes
  $("body").on("change", ".unitToggle", function () {
    var $sizeChartItem = $(this).closest(".size-chart-item"); // Get relevant chart section
    var unit = $(this).prop("checked") ? "IN" : "CM"; // Check checkbox state

    // Update the active class in size converter items
    $sizeChartItem.find(".size-chart-converter_item").removeClass("active");
    $sizeChartItem
      .find(`.size-chart-converter_item[data-type="${unit}"]`)
      .addClass("active");

    // Update table values
    updateTableValues($sizeChartItem, unit);
  });

  // Function to update table values
  function updateTableValues($sizeChartItem, unit) {
    $sizeChartItem.find("table tbody tr").each(function () {
      $(this)
        .find("td:not(:first-child)")
        .each(function () {
          const value =
            unit === "CM"
              ? $(this).attr("data-cm")
              : $(this).attr("data-in");

          $(this).text(value);
        });
    });
  }

  $("body").on("click", ".product-meta-share-button", function (){
    $('html').addClass('lock-all');
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').attr('open', '');
  })
  $("body").on("click", ".product-meta-share-button-close, .product-meta-share-overlay", function (){
    $('html').removeClass('lock-all');
    $(this).closest('.product-meta_share_wraper').find('.product-meta-share-modal').removeAttr('open', '');
  })
  $("body").on("click", ".account-login-popup, .account-login-popup-mobile", function (){
    $('html').addClass('lock-all');
    $(this).closest('.shopify-section--header, .mobile-nav__footer').find('.account-login-popup-modal, .account-login-popup-modal-mobile').attr('open', '');
  })
  $("body").on("click", ".account-login-popup-button-closee, .account-login-popup-overlay", function (){
    $('html').removeClass('lock-all');
    $(this).closest('.shopify-section--header, .mobile-nav__footer').find('.account-login-popup-modal, .account-login-popup-modal-mobile').removeAttr('open', '');
  })
  $("body").on("click", ".early_access-account-login-popup" , function () {
    $('html').addClass('lock-all');
    $(".early-access-account-login-popup").attr('open', '');
  })
  $("body").on("click", ".early-access-account-login-popup .account-login-popup-button-closee", function (){
    window.location.href = '/';
  })
  $("body").on("click", ".account-login-popup-overlay", function (){
    $('html').addClass('lock-all');
    $(this).closest(".early-access-account-login-popup").removeAttr('open', '');
  })

  $('body').on('click','.eam-notifyme_btn', function (e) {
    e.preventDefault(); // Prevent form submission
    var _this = $(this);
    $('.notify_success_msg').hide();
    $('.response_error').hide();
    const email = _this.attr('data-customeremail');

    $.ajax({
      url: "https://dev.d2cbox.com/shopify/api/v1/create_customer/",
      method: "POST",
      contentType:"application/json",
      headers: {
        "Authorization": "12430c64c413493da517fbf02dec276e"
      },
      data: JSON.stringify({
        email: email,
        tag: ' Notify me'
      }),
      success: function (response) {
        console.log(response);
        if(response.status == 1){
          _this.closest('.early_access-modal-inner-buttons_wrapper').hide();
          $('.notify_success_msg').show();
          setTimeout(function(){
            window.location.href = '/';
          },2000);
        }else{
          _this.closest('.early_access-modal-inner-buttons_wrapper').after('<p class="response_error">'+response.message+'</p>');
          _this.find('.banner--error').show();
        }
        // _this.find('[type="submit"]').attr('aria-busy', 'false');
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
        _this.closest('.early_access-modal-inner-buttons_wrapper').after('<p class="response_error">'+xhr.responseJSON.detail+'</p>');
        _this.find('.banner--error').show();
      }
    });
                  
  });   

  $(window).on('scroll', function () {
    if ($(window).scrollTop() > 100) {
      $('.go-top').addClass('show');
    } else {
      $('.go-top').removeClass('show');
    }
  });  

  $('.go-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600); 
  });

  var checkElement = setInterval(function () {
    var el = $('._appEmbedBottomLeft_1tvcr_33');

    if (el.length) {
      clearInterval(checkElement);

      setTimeout(function () {
        el.addClass('active');
      }, 5000);
    }
  }, 200);


  $(document).on('click', '.lp-video:not(.show-controls)', function (e) {
    e.preventDefault();
    $(this).addClass('show-controls');
    setTimeout(function() {
      $('.lp-video').removeClass('show-controls');
    }, 1000);
  });
  // $(document).on('click', '.lp-product__video--controls_button.sound', function () {
  //   var $btn = $(this);
  //   var video = $btn.closest('.lp-video').find('video').get(0);
  //   if (video.muted) {
  //     video.muted = false;
  //     $btn.addClass('active');
  //   } else {
  //     video.muted = true;
  //     $btn.removeClass('active');
  //   }
  // });

  // if (window.matchMedia("(max-width: 740px)").matches) {
  //   $(document).on('click', '.lp-product__video--controls_button.sound', function () {
  //     var $btn = $(this);
  //     var video = $btn.closest('.lp-video').find('video').get(0);

  //     if (video.muted) {
  //       video.muted = false;
  //       $btn.addClass('active');
  //     } else {
  //       video.muted = true;
  //       $btn.removeClass('active');
  //     }
  //   });


  //   // 👇 Auto mute when out of viewport
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       const video = entry.target;
  //       const $wrapper = $(video).closest('.lp-video');
  //       const $btn = $wrapper.find('.lp-product__video--controls_button.sound');

  //       if (!entry.isIntersecting) {
  //         video.muted = true;
  //         $btn.removeClass('active');
  //       }
  //     });
  //   }, {
  //     threshold: 0.2 // trigger when 20% visible
  //   });

  //   // Apply observer to all videos
  //   document.querySelectorAll('.lp-video video').forEach(video => {
  //     observer.observe(video);
  //   });
    
  // } else {    
  //   $(document).on('click', '.lp-product__video--controls_button.sound', function () {
  //     var $btn = $(this);
  //     var $currentVideo = $btn.closest('.lp-video').find('video');
  
  //     // If current video is muted → unmute it and mute all others
  //     if ($currentVideo.prop('muted')) {
  
  //       // 🔴 Mute ALL videos first
  //       $('.lp-video video').prop('muted', true);
  
  //       // 🔴 Remove active class from all buttons
  //       $('.lp-product__video--controls_button.sound').removeClass('active');
  
  //       // 🟢 Unmute current video
  //       $currentVideo.prop('muted', false);
  //       $btn.addClass('active');
  
  //     } else {
  //       // 🔴 If already unmuted → mute it
  //       $currentVideo.prop('muted', true);
  //       $btn.removeClass('active');
  //     }
  //   });
  // }

  // Click toggle (your existing code)
  $(document).on('click', '.lp-product__video--controls_button.sound', function () {
    var $btn = $(this);
    var video = $btn.closest('.lp-video').find('video').get(0);

    if (video.muted) {
      video.muted = false;
      $btn.addClass('active');
    } else {
      video.muted = true;
      $btn.removeClass('active');
    }
  });


  // 👇 Auto mute when out of viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      const $wrapper = $(video).closest('.lp-video');
      const $btn = $wrapper.find('.lp-product__video--controls_button.sound');

      if (!entry.isIntersecting) {
        video.muted = true;
        $btn.removeClass('active');
      }
    });
  }, {
    threshold: 0.1 // trigger when 20% visible
  });

  // Apply observer to all videos
  document.querySelectorAll('.lp-video video').forEach(video => {
    observer.observe(video);
  });
  
});

document.addEventListener("variant:changed", function (event) {
  if (event.detail.variant) {
    if (event.detail.variant.title == "Custom Size") {
      console.log(000);
      $(".custom_sizes").slideDown();
    } else {
      $(".custom_sizes-wrapper input").each(function () {
        $(this).val("");
      });
      $(".custom_sizes").slideUp();
    }
  }
});


/* ------------------------------------------------------------------
   LOGIN GATE FOR THE CART
   ------------------------------------------------------------------
   Guests (not logged-in customers) must log in before they can view
   the cart / cart drawer. Behaviour:
     1. Clicking the cart icon (or any cart link) opens the login popup
        instead of the cart drawer / cart page.
     2. "Add to cart" still adds the item, but the cart drawer does NOT
        open. Instead the same login popup is shown.
     3. Landing directly on the /cart page as a guest opens the popup.
   The popup used is the existing one shown by the account icon.
------------------------------------------------------------------ */
// (function () {
//   function isLoggedIn() {
//     return !!(window.themeVariables &&
//               window.themeVariables.settings &&
//               window.themeVariables.settings.customerLoggedIn);
//   }

//   // Opens the existing account login popup (the header one, not the
//   // early-access variant) and locks page scroll, mirroring the theme's
//   // own account-icon handler so the existing close handlers still work.
//   function openLoginPopup() {
//     $("html").addClass("lock-all");
//     $(".account-login-popup-modal")
//       .not(".early-access-account-login-popup")
//       .first()
//       .attr("open", "");
//       // set redirection url of cart drawer after user has logged in.
//       const url = new URL(window.location.href);
//       url.searchParams.set('open-cart-drawer', 'true');
//       window.simplyOtp.settings.pageUrl = url.toString();

//       const iframes = document.querySelectorAll('iframe.social_login_frame');
//       console.log(url.toString());
//       iframes.forEach(function (iframe) {
//         if (iframe.contentWindow) {
//           iframe.contentWindow.postMessage({
//             action: 'getParentUrl',
//             parentUrl: url.toString()
//           }, '*');
//         }
//       });
//   }

//   // 1) Block opening the cart drawer / navigating to the cart for guests.
//   //    Capture phase so this runs BEFORE the toggle-link's own click
//   //    handler that would otherwise open the mini-cart drawer.
//   document.addEventListener("click", function (e) {
//     if (isLoggedIn()) return;
//     var trigger = e.target.closest(
//       '[aria-controls="mini-cart"], a[href$="/cart"], a[href*="/cart?"]'
//     );
//     if (!trigger) return;
//     e.preventDefault();
//     e.stopPropagation();
//     openLoginPopup();
    
//   }, true);

//   /* open cart drawer as we get in ?open-cart-drawer=true in params. */
//   document.addEventListener('DOMContentLoaded', () => {
//     const params = new URLSearchParams(window.location.search);
//     if (params.get('open-cart-drawer') === 'true') {
//       const cartLink = document.querySelector('store-header a[href="/cart"]');
//       if (cartLink) {
//         cartLink.click();
//       }
//     }
//   });

//   // 2) For guests, never auto-open the mini-cart drawer after add-to-cart.
//   //    Capture phase so we mutate the event before the cart-drawer reads it.
//   document.addEventListener("cart:refresh", function (e) {
//     if (isLoggedIn()) return;
//     if (e.detail && e.detail.openMiniCart) {
//       e.detail.openMiniCart = false;
//     }
//   }, true);

//   // 3) After a guest adds an item, show the login popup.
//   document.addEventListener("variant:added", function () {
//     if (isLoggedIn()) return;
//     openLoginPopup();
//   });

//   // 4) Login button shown on the cart page (and anywhere else) opens the popup.
//   $("body").on("click", ".cart-login-trigger", function () {
//     openLoginPopup();
//   });

//   // 5) Guard the cart page itself for guests. The cart contents are already
//   //    hidden server-side (see main-cart.liquid); this just auto-opens the
//   //    login popup for convenience.
//   $(document).ready(function () {
//     if (!isLoggedIn() &&
//         window.themeVariables &&
//         window.themeVariables.settings &&
//         window.themeVariables.settings.pageType === "cart") {
//       openLoginPopup();
//     }
//   });
// })();
// ==============================================================
if (typeof jQuery !== 'undefined') {
  (function ($) {
    var $header = $('[data-account-header]');
    var $body = $('body');

    $header.on('click', '[data-account-header-open]', function () {
      $header.addClass('is-open');
      $body.addClass('lock-all');
    });

    $header.on('click', '[data-account-header-close]', function () {
      $header.removeClass('is-open');
      $body.removeClass('lock-all');
    });

    $(document).on('keyup', function (e) {
      if (e.key === 'Escape') {
        $header.removeClass('is-open');
        $body.removeClass('lock-all');
      }
    });
  })(jQuery);
}